import axios from 'axios';

const API_BASE_URL = 'https://pibomma.apps.dj/api';

export const fileExplorerAPI = {
  getFiles: (path) => {
    const encodedPath = encodeURIComponent(path);
    const params = path ? { path: encodedPath } : {};
    return axios.get(`${API_BASE_URL}/files`, { params });
  },
  
  getVideoUrl: (path) => {
    return `${API_BASE_URL}/video?path=${encodeURIComponent(path)}`;
  }
};